module.exports = __webpack_public_path__ + "assets/JTUSjIg1_i6t8kCHKm459WRhyzbi-f03c9d.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/JTUSjIg1_i6t8kCHKm459WRhyzbi.woff2
// module id = 844
// module chunks = 2